import React from "react";
import backgroundImage from "../../../assets/images/main_background.png";
import Grid from "@material-ui/core/Grid";
import Toolbar from "../../Toolbar";
import '../../../App.scss';
import Spinner from "../../pageComponents/Home/LuckSpinner/Spinner";
import Button from "../../pageComponents/Settings/Free/Button";
import axios from "axios";
import {rollDo,rollList,userData} from "../../../Utility/Url";
import PicoLoader from "../../pageComponents/Common/PicoLoader";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import CustomDialog from "../../pageComponents/Common/Dialog";
import Exit from "../../../assets/images/exit.png";
import goldCoin from "../../../assets/images/ic_coin.png";
import silverCoin from "../../../assets/images/ic_silver_coin.png";


import SpinnerNormalImage from "../../../assets/images/img_spinner.png";
import SpinnerVIPImage from "../../../assets/images/img_spinner_vip.png";

import SpinnerStand from "../../../assets/images/img_gardone_paye.png";
import SpinnerStandVIP from "../../../assets/images/paye_vip.png";

import ArrowVipSpinner from "../../../assets/images/arrow_spinnerr.png";
import ArrowNormalSpinner from "../../../assets/images/arrow_spinner_vip.png";

import ArrowNormalSpinnerHolder from "../../../assets/images/img_spinner_center.png";
import ArrowVIPSpinnerHolder from "../../../assets/images/img_spinner_center_vip.png";


import {dialogBackground, dialogBorderColor, dialogContentColor, dialogContentTextColor} from "../../../Utility/Theme";
import {connect} from "react-redux";
import {data as rxData} from "../../../Store/Actions/DataAction";
import ShopDialog from "../../pageComponents/Common/ShopDialog";
import {COINCHANGE} from "../../../Store/Actions/Types";


class LuckSpinner extends React.Component {
    constructor() {
        super()
        this.state = {
            vipDialogData:undefined,
            vipDialogVisible:false,
            showDialog:false,
            picoSmallLoader:false,
            images:{
                spinnerBackground:SpinnerNormalImage,
                cursorImage:ArrowNormalSpinner,
                cursorHolderImage:ArrowNormalSpinnerHolder,
                stand:SpinnerStand,
            },
            itemsOverwrite:false,
            dialogData:{
                button:{
                    text:'',
                    backgroundColor:'transparent',
                    bottomFontSize:'15px',
                    buttonTextColor:'red',
                    borderColor:'transparent'
                },
                data:{
                    dialog:{
                        success:false,
                        ok:null,
                        // message:res.data.dialog.message,
                        message:'daw',
                        style: {
                            background: dialogBackground,
                            borderColor: dialogBorderColor,
                            contentColor: dialogContentColor,
                            contentTextColor: dialogContentTextColor,
                            type: "danger",
                        },
                        cancel:{
                            action: "#cancel",
                            text: 'باشه'
                        }
                    }
                }
            },
            rollDo:null,
            time: null,
            degree:0,
            spinnerData:null,
            firstItems:[
                 {
                    id:'1',
                    name:"awd",
                    align:'flex-end',
                    text:'1',
                    type:'silver'
                },
                 {
                        id:'1',
                        name:"awd",
                        align:'flex-end',
                        text:'1',
                        type:'silver'
                    },
                 {
                        id:'1',
                        name:"awd",
                        align:'flex-end',
                        text:'1',
                        type:'silver'
                    },
                 {
                        id:'1',
                        name:"awd",
                        align:'flex-end',
                        text:'1',
                        type:'silver'
                    },
            ],
            secondItems:[
                {
                    id:'1',
                    name:"awd",
                    align:'flex-end',
                    text:'1',
                    type:'silver'
                },
                {
                    id:'1',
                    name:"awd",
                    align:'flex-end',
                    text:'1',
                    type:'silver'
                },
                {
                    id:'1',
                    name:"awd",
                    align:'flex-end',
                    text:'1',
                    type:'silver'
                },
                {
                    id:'1',
                    name:"awd",
                    align:'flex-end',
                    text:'1',
                    type:'silver'

                },
            ],
            style: {
                completed: 5,
                root: {
                    flexGrow: 1,
                    backgroundImage: "url(" + backgroundImage + ")",
                    backgroundSize: '100% 100%',
                    backgroundRepeat: 'no-repeat',
                    width: '100%',
                    backgroundColor: "#343168",
                    backgroundBlendMode: 'soft-light',
                    flex: 1,
                    minHeight: '0',
                    overflowY: 'hidden'
                },
            }
        }
    }
    shouldComponentUpdate(nextProps, nextState, nextContext) {
        const {firstItems,secondItems}=this.state
        if (firstItems.length!==0 && secondItems.length!==0 ){
            return true
        }
        else {
            return false
        }
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const {spinnerData,itemsOverwrite,firstItems,secondItems}=this.state
        if (spinnerData && itemsOverwrite === false){
            let spinnerDataList=spinnerData.list
            spinnerDataList.sort((a, b) => (a.deg > b.deg) ? 1 : -1)
            // console.log("Spinner DataKist",spinnerDataList)
            let spinnerDataListClone= [...spinnerDataList]
            let tmp1=spinnerDataList.splice(0,4)
            let tmp2=spinnerDataListClone.splice(4)

            let items=tmp1.map(data=>{
                    return {
                        id:data.id,
                        name:"iman",
                        align:'',
                        text:data.value,
                        type:data.type,
                        deg:data.deg
                    }
                }
            )
            let items2=tmp2.map(data=>{
                    return {
                        id:data.id,
                        name:"iman",
                        align:'',
                        text:data.value,
                        type:data.type,
                        deg:data.deg

                    }
                }
            )
            this.setState({
                    itemsOverwrite:true,
                }
                ,()=>{
                    this.setState({
                            firstItems:items,
                            secondItems:items2,
                        }
                    )
                })

            // console.log(firstItems , secondItems)
        }
    }

    componentDidMount() {
        this.props.toggleBottomNavbar()
        this.fetchList()
        this.fetchData()
    }
    fetchData= async()=>{
        await axios.get(userData)
            .then(res => {
                const {data}=res
                this.props.rxData(data)
            }).catch(error=>{
                    console.log(error.toString())
                }
            )
    }
    fetchList= async()=>{
        await axios.get(rollList)
            .then(res => {
                const {data}=res
                this.setState({
                    spinnerData:data
                })
                if (!data.free){
                    const images = {...this.state.images}
                    images.cursorImage = ArrowVipSpinner;
                    images.spinnerBackground = SpinnerVIPImage;
                    images.cursorHolderImage = ArrowVIPSpinnerHolder;
                    images.stand = SpinnerStandVIP;
                    this.setState({images})
                }
                // console.log(data)
            }).catch(error=>{
                    console.log(error.toString())
                }
            )
    }
    rollDo= async()=>{
        const res=await axios.get(rollDo)
            .then(res => {
                const {data}=res
                const {firstItems,secondItems}=this.state
                const {wonItem: {id}}=data
                let found = firstItems.find(items => items.id ===id);
                if (!found)
                    found=secondItems.find(items => items.id ===id);
                const rs ={
                    data:data,
                    found:found
                }
                return rs
            }).catch(error=>{
                    console.log(error.toString())
                }
            )

        return res
    }
    sleep=(ms)=> {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
    generateRandom=async()=>{
        const {spinnerData}=this.state
        if (!spinnerData.free && !spinnerData.rollvip>0){
            localStorage.setItem('redirect','/home/luck-spinner')
            const customDialog={
                button:{
                    text:'',
                    backgroundColor:'transparent',
                    bottomFontSize:'15px',
                    buttonTextColor:'red',
                    borderColor:'transparent'
                },
                data:{
                    dialog:spinnerData.shopItem,
                }
            }
            this.setState({
                vipDialogData:customDialog,
                vipDialogVisible:true
            })
        }
        else {
            this.setState({
                picoSmallLoader:true
            })
            const res = await this.rollDo()
            this.setState({
                picoSmallLoader:false,
                degree:res.found.deg+3600
            })
            const resDialogImage=res.found.type==='silver'?silverCoin:goldCoin
            setTimeout(()=>{
                const customDialog={
                    button:{
                        text:'',
                        backgroundColor:'transparent',
                        bottomFontSize:'15px',
                        buttonTextColor:'red',
                        borderColor:'transparent'
                    },
                    data:{
                        dialog:{
                            success:false,
                            ok:null,
                            message:res.data.dialog.message,
                            // message:'daw',
                            style: {
                                background: dialogBackground,
                                borderColor: dialogBorderColor,
                                contentColor: dialogContentColor,
                                contentTextColor: dialogContentTextColor,
                                type: "danger",
                                fontSize:'20px'
                            },
                            icon:resDialogImage,
                            // icon:
                            cancel:{
                                action: "#cancel",
                                text: 'باشه'
                            }
                        }
                    }
                }
                this.setState({
                    dialogData:customDialog,
                    showDialog:true
                })
                const {wonItem: {quantity, type,id}}=res.data
                this.props.rxData({coinType:type,value:quantity,type:'increment'},COINCHANGE)
            },5500)
            await this.sleep(6000)
            const images = {...this.state.images}
            const spinnerData = {...this.state.spinnerData}
            spinnerData.free = false;
            images.cursorImage = ArrowVipSpinner;
            images.spinnerBackground = SpinnerVIPImage;
            images.cursorHolderImage = ArrowVIPSpinnerHolder;
            images.stand = SpinnerStandVIP;
            this.setState({
                images,
                spinnerData
            })
        }
    }
    handleClose=(()=>{
        this.setState({
            showDialog:false,
            vipDialogVisible:false
        })
    })
    handleDialogAction=(action)=>{
        switch (action) {
            case '#cancel':
                this.setState({
                    showDialog:false,
                })
                break
            default:
                this.setState({
                    showDialog:false,
                })
        }
    }

    render() {
        const spinner ={
            degree:this.state.degree
        }

        const {
            dialogData,
            picoSmallLoader,
            spinnerData,
            itemsOverwrite,
            firstItems,
            secondItems,
            images,
            vipDialogData,
            vipDialogVisible
        }=this.state
        let button={}
        if (spinnerData){
            button={
                text:(spinnerData.free || spinnerData.rollvip>0)?'بچرخون':
                        (!spinnerData.free && spinnerData.rollvip>0)?'گردونه طلایی':
                            (!spinnerData.free && spinnerData.rollvip==0 && spinnerData.shopActive) ?'خرید طلایی':'بچرخونن'
                ,
                backgroundColor:spinnerData.free?'red':'rgba(89, 247, 200)',
                bottomFontSize:'15px',
                buttonTextColor:'#ffffff'
            }
        }
        return(
            <Grid style={this.state.style.root} direction={"column"} item container>
                <Dialog
                    // disableBackdropClick
                    open={vipDialogVisible}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    style={{background:'transparent !important'}}
                    PaperProps={{
                        style: {
                            backgroundColor: 'transparent',
                            boxShadow: 'none',
                        },
                    }}
                >
                    <DialogContent>
                        <ShopDialog action={this.handleDialogAction} data={vipDialogData}/>
                    </DialogContent>
                </Dialog>
                <Dialog
                    // disableBackdropClick
                    open={this.state.showDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    style={{background:'transparent !important'}}
                    PaperProps={{
                        style: {
                            backgroundColor: 'transparent',
                            boxShadow: 'none',
                        },
                    }}
                >
                    <DialogContent>
                        <CustomDialog action={this.handleDialogAction} data={dialogData}/>
                    </DialogContent>
                </Dialog>
                {
                    (this.state.spinnerData && itemsOverwrite)&&
                    <Grid item sm={12} justify={'center'} container direction={"column"} style={{flex:'1',minHeight:'0'}}>
                    <Grid item container id={"TTT"}>
                        <Toolbar type='sideToolbar'/>
                    </Grid>
                    <Grid item container xs={12} justify={"center"} sm={12} className='scrollBar'
                          style={{flex:'1',minHeight:'0',overflow:'auto'}}>
                        <Grid style={{marginBottom:'60px'}} xs={12} justify={"center"} sm={10}>
                            <Spinner firstItems={firstItems} secondItems={secondItems} images={images} data={spinner}/>
                        </Grid>
                        <Grid container alignItems={"center"} style={{position:'relative'}} xs={6} justify={"center"} sm={6}>
                            {
                                !picoSmallLoader&&
                                <Grid onClick={()=>{
                                    this.generateRandom()
                                }} xs={12} justify={"center"} style={{height:'100px',position:'relative'}} alignItems={"center"}
                                      sm={12}>
                                    <Button data={button}/>
                                </Grid>
                            }
                            {
                                picoSmallLoader &&
                                <Grid sm={3} xs={3} container alignItems={"center"} direction={"row-reverse"} justify={"center"}
                                      style={{position:'relative',height:'50px'}}
                                >
                                    <Grid item container justify={"center"} alignItems={"center"} style={{position:'absolute'}}>
                                        <PicoLoader/>
                                    </Grid>
                                </Grid>
                            }
                        </Grid>
                        {/*<Grid onClick={()=>{*/}
                        {/*    this.generateRandom()*/}
                        {/*}} style={{height:'100px'}} xs={6} justify={"center"} sm={6}>*/}
                        {/*    <Button data={button}/>*/}
                        {/*</Grid>*/}
                    </Grid>
                </Grid>
                }
                {
                    !this.state.spinnerData &&
                    <Grid m={2} xs={2} container alignItems={"center"} direction={"row-reverse"} justify={"center"}
                          style={{position:'relative',
                              top:'50%',left:'50%',transform:'translate(-50%,-50%)'}}
                    >
                        <Grid item container justify={"center"} style={{position:'absolute'}}>
                            <PicoLoader/>
                        </Grid>
                    </Grid>
                }
            </Grid>
        )
    }
}
const mapStateToProps=state=>({
    UserData:state.UserData
})
export default connect(mapStateToProps,{rxData})(LuckSpinner)